import { initCore } from 'src/lib/init.js'

import 'src/styles/aristotle.help.less'

initCore()
